export default {
    setApiLogsData(state, payload) {
        state.apiLogsData = payload
    },
    setTotalRecords(state, payload) {
        state.totalRecords = payload
    },
}
